import React, { useState, useEffect } from "react";

import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { Spin, Switch, Tooltip } from "antd";


const FtpDetails = () => {
  const { t } = useTranslation();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [testLoading, setTestLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [dealerId, setDealerId] = useState(0);

  const [ftpDetails, setFtpDetails] = useState({
    path: "",
    userId: "",
    password: "",
    portNo: "",
    IsSSL: true,
  });

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetMegentoMappingForXML(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  const handleGetMegentoMappingForXML = (id) => {
    let inputData = {
      dealerId: id | 0,
    };
    try {
      setLoading(true);
      AdminToolsDataService.GetMegentoMappingForXML(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setFtpDetails((prevState) => ({
                ...prevState,
                path: responseData.apiURL,
                userId: responseData.userName,
                password: responseData.password,
                portNo: responseData.portNo,
                IsSSL: responseData.enableSync,
              }));
            }
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setDisableBtn(false);
      setFtpDetails({
        ...ftpDetails,
        [name]: e,
      });
    } else {
      setDisableBtn(false);
      setFtpDetails({
        ...ftpDetails,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleSubmit = () => {
    try {
      setSubmitLoading(true);
      let inputData = {
        dealerID: dealerId,
        apiUrl: ftpDetails.path ? ftpDetails.path : "",
        portNo: ftpDetails.portNo,
        username: ftpDetails.userId ? ftpDetails.userId : "",
        password: ftpDetails.password ? ftpDetails.password : "",
        enablessl: ftpDetails.IsSSL,
      };
      setLoading(true);
      AdminToolsDataService.SaveFtpDetailsSync(inputData)
        .then((response) => {
          let message = response.data.message;
          setLoading(false);
          setSubmitLoading(false);
          if (message === "Success") {
            NotificationManager.success(t("Data Updated Successfully."));
            handleGetMegentoMappingForXML(dealerId);
          } else {
            NotificationManager.error(t("Data not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setSubmitLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSubmitLoading(false);
    }
    setDisableBtn(true);
  };

  const isFtpDetailsFilled =
    String(ftpDetails.path || "").trim() !== "" &&
    String(ftpDetails.userId || "").trim() !== "" &&
    String(ftpDetails.password || "").trim() !== "" &&
    String(ftpDetails.portNo || "").trim() !== "";

  const handleTestFtp = () => {
    if (!isFtpDetailsFilled) {
      NotificationManager.warning(t("Please fill in the FTP details first."));
      return;
    }
    let inputData = {
      dealerID: dealerId,
      apiUrl: String(ftpDetails.path).trim(),
      portNo: Number(ftpDetails.portNo) || 0,
      username: String(ftpDetails.userId).trim(),
      password: ftpDetails.password,
      enablessl: ftpDetails.IsSSL,
    };
    setTestLoading(true);
    AdminToolsDataService.TestFtpConnection(inputData)
      .then((response) => {
        setTestLoading(false);
        let message = response.data.message;
        let responseData = response.data.responseData;
        if (message === "Success") {
          NotificationManager.success(t("FTP connection successful."));
        } else {
          NotificationManager.error(
            responseData && responseData.message
              ? responseData.message
              : t("FTP connection failed.")
          );
        }
      })
      .catch((error) => {
        setTestLoading(false);
        let errorMessage =
          error && error.response && error.response.data
            ? error.response.data.message
            : "";
        NotificationManager.error(
          errorMessage
            ? String(errorMessage).replace(/^Error : /, "")
            : t("FTP connection failed.")
        );
      });
  };

  return (
    <div className="prodetail__section">
      <div className="form__fields">
        <div className="col-md-12">
          <div className="prod__maindiv data__maping diamond__mapping">
            <div className="row">
              <div className="col-md-12">
                <h4 className="workarea__heading mt-0">
                  {" "}
                  {t("Enter FTP Detail for SYNC File Below")}{" "}
                </h4>
              </div>

              <Spin spinning={loading}>
                <div className="col-md-6">
                  <div className="input__block">
                    <lable> {t("Path")} </lable>
                    <input
                      type="text"
                      name="path"
                      value={ftpDetails.path}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="input__block">
                    <lable> {t("User Id")} </lable>
                    <input
                      type="text"
                      name="userId"
                      value={ftpDetails.userId}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="input__block">
                    <lable> {t("Password")} </lable>
                    <input
                      type="text"
                      name="password"
                      autoComplete="new-password"
                      value={ftpDetails.password}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="input__block">
                    <lable> {t("Port No")} </lable>
                    <input
                      type="text"
                      name="portNo"
                      value={ftpDetails.portNo}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="input__block">
                    <lable className="d-block mb-2"> {t("Is SSL?")} </lable>
                    <Switch
                      checkedChildren={t("Yes")}
                      unCheckedChildren={t("No")}
                      defaultChecked
                      onChange={(e) => handleOnChange(e, "select", "IsSSL")}
                      checked={ftpDetails.IsSSL}
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <button
                    className={disableBtn ? "disabled-btn" : "primary-btn"}
                    disabled={disableBtn}
                    loading={submitLoading}
                    onClick={handleSubmit}
                  >
                    {" "}
                    {t("Save Details")}{" "}
                  </button>
                  {isFtpDetailsFilled && (
                    <button
                      type="button"
                      className="ghost-btn"
                      style={{ marginLeft: "10px" }}
                      disabled={testLoading}
                      onClick={handleTestFtp}
                    >
                      {testLoading ? t("Testing...") : t("Test FTP")}
                    </button>
                  )}
                </div>
              </Spin>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FtpDetails;
